document.addEventListener("DOMContentLoaded", function () {
    // Tabs for desktop
    const tabs = document.querySelectorAll(".tab-title");
    const contents = document.querySelectorAll(".tab-content");

    tabs.forEach((tab, index) => {
        tab.addEventListener("click", function () {
            tabs.forEach(tab => tab.classList.remove("active"));
            contents.forEach(content => content.classList.remove("active"));

            tab.classList.add("active");
            contents[index].classList.add("active");

            if (contents[index].querySelector('.tab-faq-box')) {
                const faqTitles = contents[index].querySelectorAll(".tab-faq-title");
                const faqContents = contents[index].querySelectorAll(".tab-faq-content");

                faqTitles.forEach(faqTitle => faqTitle.classList.remove("active"));
                faqContents.forEach(faqContent => faqContent.classList.remove("active"));

                if (faqTitles.length > 0 && faqContents.length > 0) {
                    faqTitles[0].classList.add("active");
                    faqContents[0].classList.add("active");
                }
            }
        });
    });

    const firstContent = document.querySelector(".tab-content.active");
    if (firstContent && firstContent.querySelector('.tab-faq-box')) {
        const firstFaqTitle = firstContent.querySelector(".tab-faq-title");
        const firstFaqContent = firstContent.querySelector(".tab-faq-content");

        if (firstFaqTitle && firstFaqContent) {
            firstFaqTitle.classList.add("active");
            firstFaqContent.classList.add("active");
        }
    }

    const faqTitles = document.querySelectorAll(".tab-faq-title");
    const faqContents = document.querySelectorAll(".tab-faq-content");

    faqTitles.forEach((title, index) => {
        title.addEventListener("click", function () {
            faqTitles.forEach(faqTitle => faqTitle.classList.remove("active"));
            faqContents.forEach(faqContent => faqContent.classList.remove("active"));

            title.classList.add("active");
            faqContents[index].classList.add("active");
        });
    });

    // Accordion for mobile
    const accordionHeaders = document.querySelectorAll(".accordion-header");
    const accordionContents = document.querySelectorAll(".accordion-content");

    accordionHeaders.forEach((header, index) => {
        header.addEventListener("click", function () {
            const content = accordionContents[index];
            const arrow = header.querySelector(".arrow");

            accordionHeaders.forEach(h => {
                if (h !== header) {
                    h.classList.remove("active");
                    h.querySelector(".arrow").style.transform = "rotate(0deg)"; // Reset arrow rotation
                }
            });

            accordionContents.forEach(c => {
                if (c !== content) {
                    c.classList.remove("active");
                }
            });

            header.classList.toggle("active");
            content.classList.toggle("active");

            if (header.classList.contains("active")) {
                arrow.style.transform = "rotate(90deg)"; // Rotate arrow when active
            } else {
                arrow.style.transform = "rotate(0deg)"; // Reset arrow rotation
            }
        });
    });
});
